import Vue from 'vue';
import './plugins/axios'
import App from './App.vue';
import router from '@/router';
import store from '@/store';
import './plugins/element.js'
import D2Crud from '@d2-projects/d2-crud'
import VueAMap from 'vue-amap';
// 导入全局组件
import './components/index';
Vue.config.productionTip = false;
// v-charts
import VCharts from 'v-charts'
Vue.use(VCharts)
Vue.use(D2Crud)
Vue.use(VueAMap)
VueAMap.initAMapApiLoader({
  // 高德的key
  key: '1cc4534f215bcd631e6426ea3cb7c233',
  // 插件集合
  plugin: ['AMap.Autocomplete', 'AMap.Geocoder', 'AMap.MouseTool', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor'],
  // 高德 sdk 版本，默认为 1.4.4
  v: '1.4.10'
});
const app = new Vue({
  router,
  store,
  render: h => h(App),
})//.$mount('#app')
window.APP = app;
app.$store.dispatch('getDictionaries').then((data)=>{
  app.$store.dispatch('getInitData').then(() => {
    app.$store.dispatch('getAsideMenu').then(() => {
      app.$mount('#app')
    })
  })
})
Vue.directive('focus', function (el:any) {
  el.querySelector('input').focus()
})

